import type {PageRouteConfig} from '@router';

import NotificationCenter from 'modules/NotificationCenter/NotificationCenter';

export function createNotificationCenterRoute(): PageRouteConfig {
  return {
    element: <NotificationCenter />,
    layout: {
      title: 'پیام‌ها',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
